import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';
import { ProductMenuFilterOption } from '../models/CategoryModel';

export class ProductAccessoryService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/productAccessory`;

    public RouteGetBrands = () => `${this.baseUrl}/getBrands`;
    public getBrands(): JQueryPromise<any> {
        return $.ajax(this.RouteGetBrands(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetTopBrands = () => `${this.baseUrl}/getTopBrands`;
    public getTopBrands(): JQueryPromise<any> {
        return $.ajax(this.RouteGetTopBrands(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetTopCategories = () => `${this.baseUrl}/getTopCategories`;
    public getTopCategories(): JQueryPromise<any> {
        return $.ajax(this.RouteGetTopCategories(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetSizes = () => `${this.baseUrl}/getSizes`;
    public getSizes(): JQueryPromise<any> {
        return $.ajax(this.RouteGetSizes(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetMenu = () => `${this.baseUrl}/getCategories`;
    public getMenu(model: ProductMenuFilterOption): JQueryPromise<any> {
        return $.ajax(this.RouteGetMenu(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetShoppingByMenu = () => `${this.baseUrl}/getShoppingByMenu`;
    public getShoppingByMenu(): JQueryPromise<any> {
        return $.ajax(this.RouteGetShoppingByMenu(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}